import { useContext } from 'react';
import { ThemeContext } from 'features/theme/ThemeContext';

const useColorMode = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useColorMode must be used within a ThemeProvider');
  }
  return context;
};

export { useColorMode };
